import HiddenBalancesIcon from '@/shared/assets/hidden-balances-icon.svg?react';
import DisplayedBalancesIcon from '@/shared/assets/displayed-balances-icon.svg?react';

interface Props {
  isBalancesHidden: boolean;
  title: string;
  setIsBalancesHidden: () => void;
}

export const HideBalanceSection = ({
  isBalancesHidden,
  setIsBalancesHidden,
  title,
}: Props) => {
  const Icon = isBalancesHidden ? HiddenBalancesIcon : DisplayedBalancesIcon;

  return (
    <div
      onClick={() => setIsBalancesHidden()}
      className={
        'cursor-pointer h-[2.4rem] flex flex-row items-center justify-center gap-[0.5rem]'
      }>
      <Icon className={'h-[1.6rem] w-[1.6rem]'} />
      <span className={'medium6 text-secondary pointer'}>{title}</span>
    </div>
  );
};
